module.exports = __webpack_public_path__ + "img/P4-0-2.1af33d05.svg";